module.exports = __webpack_public_path__ + "img/symbol_6.513620d0.png";